import { JastBuilder, JqlAnonymizerVisitor } from '@atlaskit/jql-ast';
import { fg } from '@atlassian/jira-feature-gating';
import type { TextSearchInputClauseType } from '@atlassian/jira-jql-utils/src/utils/text-search-input-clause/types.tsx';
import { JqlClauseCollectingVisitor } from './jql-clause-collecting-visitor/index.tsx';
import type { ClauseMap } from './types.tsx';
import { UnsupportedRefinementError } from './unsupported-refinement-error/index.tsx';

export const getStateFromJQL = (jql: string, isModeSwitcherEnabled = false) => {
	const ast = new JastBuilder().build(jql);
	let clauseMap: ClauseMap = {};
	let textSearchInputClause: TextSearchInputClauseType;
	let anonymizedJql = '';

	if (ast.query) {
		try {
			({ clauseMap, textSearchInputClause } = new JqlClauseCollectingVisitor(jql).visit(ast.query));

			anonymizedJql = new JqlAnonymizerVisitor().visit(ast.query);
		} catch (e) {
			if (
				isModeSwitcherEnabled &&
				e instanceof UnsupportedRefinementError &&
				fg('list_lovability_improving_filters')
			) {
				return { ast, clauseMap, jql, textSearchInputClause, anonymizedJql, isModeSwitcherEnabled };
			}
			throw e;
		}
	} else {
		throw new Error();
	}

	return { ast, clauseMap, jql, textSearchInputClause, anonymizedJql, isModeSwitcherEnabled };
};
